import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  placeholder: {
    position: 'absolute',
    left: '1rem',
    bottom: '0.5rem',
    fontSize: 11
  }
}))

const Placeholder = props => {
  const classes = useStyles()

  return (
    <Typography color='textSecondary' className={classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

Placeholder.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired
}

export default Placeholder
